import { useQuery } from "@apollo/client";

import { ManagedType } from "gql/graphql";
import { GET_ORGANIZATION_GROUPS } from "pages/organization/groups/queries";
import { Logger } from "utils/logger";

const useGroupOnTrial = ({
  organizationId,
}: {
  organizationId: string;
}): {
  isGroupTrial: boolean;
} => {
  const { data } = useQuery(GET_ORGANIZATION_GROUPS, {
    fetchPolicy: "cache-first",

    onError: ({ graphQLErrors }): void => {
      graphQLErrors.forEach((error): void => {
        Logger.warning("An error occurred fetching organization groups", error);
      });
    },
    skip: organizationId === "",
    variables: {
      organizationId,
    },
  });

  const isGroupTrial =
    data?.organization.groups[0]?.managed === ManagedType.Trial;

  return { isGroupTrial };
};

export { useGroupOnTrial };
